import envVar from '../config/envVars';
import httpDelete from './httpClient/httpDelete';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import httpPut from './httpClient/httpPut'; // Import httpPut

const getTermsFor = async (
  grade: string,
  division: string,
  academicYear: string,
  school: string
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/terms`,
    {
      grade,
      division,
      academicYear
    },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};
const getExamsFor = async (
  grade: string,
  division: string,
  academicYear: string,
  school: string,
  termId: string
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams`,
    {
      grade,
      division,
      academicYear,
      termId
    },
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};
interface CreateExamPayload {
  academicYear: string;
  grade: string;
  division: string;
  termId: string;
  examName: string;
  school: string;
}
const createExam = async (payload: CreateExamPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${payload.school}/exams/create`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};
interface CloneExamPayload {
  cloneFrom: {
    academicYear: string;
    grade: string;
    division: string;
    termId: string;
  };
  cloneTo: {
    academicYear: string;
    grade: string;
    division: string;
    termId: string;
  };
}
const cloneExams = async (school: string, payload: CloneExamPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams/clone`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const deleteExam = async (school: string, examId: string) => {
  return httpDelete(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams/${examId}`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const getScoringTypes = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/scoring-types`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const getGradeScales = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade-scales`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const getSubjects = async (school: string, grade: string, division: string) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/grade/${grade}/division/${division}/subjects`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

interface UpdateExamPayload {
  name: string;
  termId: string;
  subjects: {
    subjectId: string;
    scoringType: string;
    maxMarks?: number;
    gradeScaleId?: string;
  }[];
}

const updateExam = async (
  school: string,
  examId: string,
  payload: UpdateExamPayload
) => {
  return httpPut(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams/${examId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

interface GetMarksListPayload {
  academicYear: string;
  grade: string;
  division: string;
  termId: string;
  examId: string;
}

const getMarksList = async (school: string, payload: GetMarksListPayload) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams/marks/list`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

interface ExamEvaluationDetail {
  examId: string;
  subjectId: string;
  disableEvaluation: boolean;
}

export interface UpdateExamEvaluationPayload {
  examEvaluationDetails: ExamEvaluationDetail[];
}

const updateExamEvaluations = async (
  school: string,
  payload: UpdateExamEvaluationPayload
) => {
  return httpPut(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/exams/evaluation`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

const examApis = {
  getTermsFor,
  getExamsFor,
  createExam,
  cloneExams,
  deleteExam,
  getScoringTypes,
  getGradeScales,
  getSubjects,
  updateExam,
  getMarksList,
  updateExamEvaluations
};
export default examApis;
